import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { getDateTime } from "utils/date";

//제어 Data 전송 로그
export default function DataTransmissionLogComponent() {
  const itemsPerPage = 100;
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getControlSendLogListByUrl(url);
      } else {
        result = await dbmsApi.getControlSendLogList(
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard overTableScroll">
        <div class="top_board pc">
          <p class="title_board">제어 Data 전송 로그</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div class="select_box">
                <button class="btn_select">
                  <p>화재수신기 일련번호</p>
                </button>
              </div>
              <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src="/images/my_btn_mb.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">제어 Data 전송 로그</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board">
          <div class="wrap_table scroll_table">
            <div class="containerTable dbmsTable statusReceiverLogTable">
              <ul class="head_table">
                <li>
                  <p>관리 ID</p>
                </li>
                <li>
                  <p>화재수신기 관리 ID</p>
                </li>
                <li>
                  <p>제어자(계정)</p>
                </li>
                <li>
                  <p>전송일시</p>
                </li>
                <li>
                  <p>제어 메세지 타입</p>
                </li>
                <li>
                  <p>장치 코드</p>
                </li>
                <li>
                  <p>제어값</p>
                </li>
                <li>
                  <p>제어송신결과</p>
                </li>
              </ul>

              <div class="body_table">
                <div class="inner_table_wrap">
                  {dataSource.results &&
                    dataSource.results.map((item, index) => (
                      <div class="wrap_table_item">
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.id}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.fireReceiverId}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.controller}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {getDateTime(new Date(item.time))}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.controlMessageType}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.deviceCode}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.controlValue}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_02">
                          <p class="cont_table_item">
                            {item.controlSendResult}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wrap_controll">
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>
      </div>
    </>
  );
}
